var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.1112 9.7793C4.70544 9.7793 4.375 10.1092 4.375 10.5155C4.375 10.9212 4.70544 11.2511 5.1112 11.2511C5.51695 11.2511 5.84741 10.9212 5.84741 10.5155C5.84741 10.1092 5.51695 9.7793 5.1112 9.7793Z",
    fill: "#484848"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.1112 6.26465C4.70544 6.26465 4.375 6.59451 4.375 7.00084C4.375 7.4066 4.70544 7.73646 5.1112 7.73646C5.51695 7.73646 5.84741 7.4066 5.84741 7.00084C5.84741 6.59451 5.51695 6.26465 5.1112 6.26465Z",
    fill: "#484848"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.1112 2.74902C4.70544 2.74902 4.375 3.07888 4.375 3.48522C4.375 3.89097 4.70544 4.22083 5.1112 4.22083C5.51695 4.22083 5.84741 3.89097 5.84741 3.48522C5.84741 3.07888 5.51695 2.74902 5.1112 2.74902Z",
    fill: "#484848"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.89 9.7793C8.48425 9.7793 8.15381 10.1092 8.15381 10.5155C8.15381 10.9212 8.48425 11.2511 8.89 11.2511C9.29576 11.2511 9.6262 10.9212 9.6262 10.5155C9.6262 10.1092 9.29576 9.7793 8.89 9.7793Z",
    fill: "#484848"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.89 6.26465C8.48425 6.26465 8.15381 6.59451 8.15381 7.00084C8.15381 7.4066 8.48425 7.73646 8.89 7.73646C9.29576 7.73646 9.6262 7.4066 9.6262 7.00084C9.6262 6.59451 9.29576 6.26465 8.89 6.26465Z",
    fill: "#484848"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.89 4.22083C9.29576 4.22083 9.6262 3.89097 9.6262 3.48464C9.6262 3.07888 9.29576 2.74902 8.89 2.74902C8.48425 2.74902 8.15381 3.07888 8.15381 3.48464C8.15381 3.89097 8.48425 4.22083 8.89 4.22083Z",
    fill: "#484848"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrag);
export default __webpack_public_path__ + "static/media/drag.c0601b958b881212622ce470f18e0bc5.svg";
export { ForwardRef as ReactComponent };